var registerPrimitive = require('../primitives').registerPrimitive;

registerPrimitive('a-gltf-model', {
  mappings: {
    src: 'gltf-model'
  }
});



// WEBPACK FOOTER //
// ./node_modules/aframe/src/extras/primitives/primitives/a-gltf-model.js